import React, {PureComponent} from "react";
import Facebook from "../../ui/facebook";
import Twitter from "../../ui/twitter";
import Linkedin from "../../ui/linkedin";
import Messenger from "../../ui/messenger";
import Whatsapp from "../../ui/whatsapp";
import Tiktok from "../../ui/tiktok";
import InstagramIcon from 'mdi-react/InstagramIcon';
import PinterestIcon from 'mdi-react/PinterestIcon';
import SnapchatIcon from 'mdi-react/SnapchatIcon';
import WhatsappIcon from 'mdi-react/WhatsappIcon';
import YoutubeIcon from 'mdi-react/YoutubeIcon';
import AmbassadorHelper from "../../utils/AmbassadorHelper";
import "./AmbassadorHeader.scss";
import {Avatar, Box, Chip, Container, Dialog, DialogContent, Grid, IconButton, Link, Typography} from "@mui/material";
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import {isMobile} from "react-device-detect";
import {QRCodeSVG as QRCode} from 'qrcode.react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import CreatorCertifications from "../CreatorCertifications/CreatorCertifications";
import brand from "./brand.json";

class AmbassadorHeader extends PureComponent {
    state = {
        openWhatsApp: false,
        openText: false
    }
    getSocialNetworks = (ambassador, dataKey) => {
        const array = [];
        if (ambassador && ambassador.data && (dataKey && ambassador.data[dataKey])) {
            const socialHandles = ambassador.data[dataKey];
            Object.entries(socialHandles).forEach(s => {
                let objectResponse = {};
                objectResponse[s[0]] = s[1];
                if (s[1] !== "")
                    array.push(objectResponse);
            });

        }
        return array;
    }
    getCertifications = (ambassador, dataKey = "certifications") => {

        if (ambassador && ambassador.data && (dataKey && ambassador.data[dataKey])) {
            const certifications = ambassador.data[dataKey];
            if (typeof certifications === "string") {
                const strToArray = certifications.split(',');
                if (strToArray.length > 0) {
                    return strToArray;
                }
            }
            if (certifications && certifications.length > 0) {
                return certifications;
            }
        }
        return [];
    }

    getStyleTags = (ambassador, dataKey = "style_tags") => {

        if (ambassador && ambassador.data && (dataKey && ambassador.data[dataKey])) {
            const style_tags = ambassador.data[dataKey];
            if (typeof style_tags === "string") {
                const strToArray = style_tags.split(',');
                if (strToArray.length > 0) {
                    return strToArray;
                }
            }
            if (style_tags && style_tags.length > 0) {
                return style_tags;
            }
        }
        return [];
    }

    formatStyleTags(string) {
        switch (string) {
            case "classic":
                return "Classic";
            case "elegant":
                return "Elegant";
            case "timeless":
                return "Timeless";
            case "sophisticated":
                return "Sophisticated";
            case "trendy":
                return "Trendy";
            case "bold":
                return "Bold";
            case "unapologetic":
                return "Unapologetic";
            case "expressive":
                return "Expressive";
            case "unique":
                return "Unique";
            case "maximalist":
                return "Maximalist";
            case "extra":
                return "Extra";
            case "confidant":
                return "Confidant";
            case "authentic":
                return "Authentic";
            case "elevated":
                return "Elevated";
            default:
                return string;
        }
    }

    cleanName(networkName) {
        if (networkName.indexOf("_chat") !== -1) {
            return networkName.replace("_chat", "")
        } else {
            return networkName.replace("_url", "")
        }
    }

    getSocialIcon(socialName) {
        switch (socialName) {
            case "instagram":
                return <InstagramIcon color={"#000000"}/>;
            case "twitter":
                return <Twitter color={"#000000"}/>;
            case "facebook":
                return <Facebook color={"#000000"}/>;
            case "pinterest":
                return <PinterestIcon color={"#000000"}/>;
            case "snapchat":
                return <SnapchatIcon color={"#000000"}/>;
            case "tiktok":
                return <Tiktok/>;
            case "whatsapp":
                return <WhatsappIcon color={"#000000"}/>;
            case "linkedin":
                return <Linkedin/>;
            case "youtube":
                return <YoutubeIcon size={30} color={"#000000"}/>
            case "whatsapp_messaging":
                return <Whatsapp/>;
            case "facebook_messaging":
                return <Messenger/>;
        }
    }

    fixName(networkName) {
        if (networkName === "whatsapp")
            return "WhatsApp";
        else if (networkName === "tiktok")
            return "TikTok";
        else if (networkName === "linkedin")
            return "LinkedIn";
        else if (networkName === "youtube")
            return "YouTube";
        return networkName;
    }

    checkWhatsApp(url) {
        if (!url) return;
        const whatsBaseUrl = "https://wa.me/";
        url = typeof url !== 'number' ? url.replace("+", "") : url.toString();
        return (url.indexOf(whatsBaseUrl) == -1) ? whatsBaseUrl + url : url;
    }

    renderSocials = (value, index) => {
        const fieldName = Object.keys(value)[0];
        const networkName = this.cleanName(fieldName);
        const link = networkName === "whatsapp" ? this.checkWhatsApp(value[fieldName]) : value[fieldName];
        return <Link href={link} key={index} target={"_blank"}>
            <Box className={"icon " + networkName}>
                {this.getSocialIcon(networkName)}
            </Box>
        </Link>
    }

    renderMessagingIcons(item, index) {
        const fieldName = Object.keys(item)[0];
        const link = fieldName === "whatsapp" ? this.checkWhatsApp(item[fieldName]) : item[fieldName];
        return <a href={link} key={index} target={"_blank"}>
            {this.getSocialIcon(fieldName + "_messaging")}
        </a>
    }

    clickSMS = e => {
        if (!isMobile) {
            e.preventDefault();
            e.stopPropagation();
            this.setState({openText: true})
        } else {
            return e;
        }
    }
    clickWhatsApp = e => {
        if (!isMobile) {
            e.preventDefault();
            e.stopPropagation();
            this.setState({openWhatsApp: true})
        } else {
            return e;
        }
    }
    closeModal = () => {
        this.setState({openText: false, openWhatsApp: false})
    }
    getPhoneNumber(){
        const env = ClientConfigurationHelper.getGlobalConfiguration().phpEnvName;
        return env === 'app' ? brand.phone_prod  : brand.phone_test;
    }
    getWhatsAppUrl = (ambassador) => {

        let phoneNumber = this.getPhoneNumber();
        const type = ambassador?.data?.sms_type || "";

        if(type === "live_person" && ambassador?.data?.phone_number_live_person){
            const phone_number = ambassador?.data?.phone_number_live_person || "";
            const cleanNumber = phone_number.replace(/[^\d.]/g, '');
            const WABody = ambassador?.data?.live_person_id ? `?text=${ambassador?.data?.live_person_id}` : '';
            return `https://wa.me/${cleanNumber}${WABody}`;
        }

        if (ambassador && ambassador.first_name && ambassador.last_name) {
            return `https://wa.me/1${phoneNumber}?text=@${ambassador.first_name}.${ambassador.last_name}`;
        } else {
            return '';
        }
    }
    getSMS = (forQR = false) => {
        const {ambassador} = this.props;
        let phoneNumber = this.getPhoneNumber();
        const type = ambassador?.data?.sms_type || "";
        const to = forQR ? 'SMSTO' : 'sms';
        if(type === "live_person" && ambassador?.data?.phone_number_live_person){
            const attachSection = forQR ? ':' : '?&body=';
            const smsBody = ambassador?.data?.live_person_id ? `${attachSection}${ambassador?.data?.live_person_id}` : '';
            const cleanNumber = ambassador?.data?.phone_number_live_person.replace(/[^\d.]/g, '');
            phoneNumber = cleanNumber+smsBody;
        }
        if(type === "heymarket" && ambassador?.data?.phone_number_heymarket){
            const cleanNumber = ambassador?.data?.phone_number_heymarket.replace(/[^\d.]/g, '');
            phoneNumber = cleanNumber;
        }
        return `${to}:${phoneNumber}`
    }
    render() {
        const {ambassador} = this.props;
        const storefront_details = AmbassadorHelper.getStoreFrontDetails(ambassador);
        const displayName = AmbassadorHelper.getDisplayName(ambassador);
        const creatorBio = (storefront_details && storefront_details.creator_bio)
            ? storefront_details.creator_bio : "";
        const socials = this.getSocialNetworks(ambassador, "social_handles");

        const certifications = this.getCertifications(ambassador);
        const style_tags = this.getStyleTags(ambassador);

        const showPhones = AmbassadorHelper.showPhones(ambassador);

        const bgImgDesktop = ClientConfigurationHelper.getGlobalConfiguration().dependency_root + "static/images/" + brand.storefront_cover_desktop;
        const bgImgMobile = ClientConfigurationHelper.getGlobalConfiguration().dependency_root + "static/images/" + brand.storefront_cover_mobile;
        const jrniId = ambassador?.data?.jrni_id || "";
        return <div data-testid="ambassador-header">
            <Box
                minHeight={{sm: '423px'}}
                paddingTop={{sm: '56px'}}
                paddingBottom={{sm: '56px'}}
                sx={{
                    backgroundImage: {xs: 'none', sm: `url(${bgImgDesktop})`},
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                <Box maxHeight={'80px'} mb={2} justifyContent={'center'} display={{xs: 'flex', sm: 'none'}} sx={{
                    backgroundImage: {sm: 'none', xs: `url(${bgImgMobile})`},
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                    <Avatar
                        sx={{
                            height: {
                                sm: 220,
                                xs: 96
                            },
                            width: {
                                sm: 220,
                                xs: 96
                            }
                        }}
                        src={AmbassadorHelper.getAmbassadorPhoto(ambassador)}/>
                </Box>
                <Container>
                    <Grid container>
                        <Grid item sm={12} md={3} display={{xs: 'none', sm: 'flex'}}>
                            <Avatar
                                sx={{
                                    height: {
                                        lg: 220,
                                        sm: 170,
                                        xs: 96
                                    },
                                    width: {
                                        lg: 220,
                                        sm: 170,
                                        xs: 96
                                    }
                                }}
                                src={AmbassadorHelper.getAmbassadorPhoto(ambassador)}/>
                        </Grid>
                        <Grid item sm={12} md={7}>
                            <Box mb={3} mt={{xs: 1, sm: 0}}>
                                <Typography variant={'h1'} sx={{textAlign: {xs: 'center', sm: 'left'}}}
                                            fontSize={{xs: '32px !important', sm: '48px !important'}}
                                            lineHeight={{xs: '38px !important', sm: '58px !important'}}>
                                    {displayName}
                                </Typography>
                            </Box>
                            {(certifications && certifications.length > 0) &&
                                <Box mb={3} display={'flex'} justifyContent={{xs: 'center', sm: 'left'}}>
                                    <Grid container justifyContent={{xs: 'center', sm: 'left'}}>
                                        {
                                            certifications.map((item, index) => {
                                                return <Grid item key={item + index}><CreatorCertifications
                                                    certificateId={item}/></Grid>
                                            })
                                        }
                                    </Grid>
                                </Box>}
                            <Box mb={3}>
                                <Typography component={'div'} sx={{textAlign: {xs: 'center', sm: 'left'}}}>
                                    {creatorBio}
                                </Typography>
                            </Box>
                            {(style_tags && style_tags.length > 0) &&
                                <Box mb={3} display={'flex'} justifyContent={{xs: 'center', sm: 'left'}}>
                                    <Grid container justifyContent={{xs: 'center', sm: 'left'}}>
                                        {
                                            style_tags.map((item, index) => {
                                                return <Grid item key={item + index}><Chip sx={{
                                                    marginRight: {xs: '4px', sm: '8px'},
                                                    marginLeft: {xs: '4px', sm: 0},
                                                    fontSize: '14px',
                                                    padding: 0,
                                                    color: '#323232',
                                                    borderColor: '#ebebeb',
                                                    marginBottom: '8px'
                                                }} label={this.formatStyleTags(item)} variant="outlined"/></Grid>
                                            })
                                        }
                                    </Grid>
                                </Box>}
                            <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'}
                                 justifyContent={{xs: 'center', sm: 'left'}} sx={{
                                '& .MuiTypography-body1': {
                                    fontSize: {
                                        lg: '16px',
                                        md: '12px',
                                        xs: '16px'
                                    },
                                    lineHeight:{
                                        lg: '24px',
                                        md: '18px',
                                        xs: '24px'
                                    }
                                },
                                '& .MuiSvgIcon-root': {
                                    width: {
                                        lg: '24px',
                                        md: '10px',
                                        xs: '24px'
                                    },
                                    height: {
                                        lg: '24px',
                                        md: '10px',
                                        xs: '24px'
                                    }
                                }
                            }}>
                                <Link target={'_blank'} href={brand.appointment_link + "/" + jrniId} underline={'none'}
                                      sx={{"&:hover": {textDecoration: 'none !important'}}}
                                      width={{xs: '100%', sm: 'auto', lg: 'auto'}} pb={{xs: 1, sm: 0}}>
                                    <Box display={'flex'} alignItems={'center'} border={'1px solid #000000'} px={3}
                                         py={1.5} justifyContent={'center'}
                                         sx={{"&:hover": {backgroundColor: '#ebebeb'}}}>
                                        <CalendarTodayOutlinedIcon sx={{width: 24, height: 24, fill: '#000000'}}/>
                                        <Typography ml={{xs: 1, md: 0.5, lg: 1}} component={'span'}>BOOK A CONSULTATION</Typography>
                                    </Box>
                                </Link>
                                { showPhones && <Link href={this.getSMS()} onClick={this.clickSMS} underline={'none'}
                                      marginTop={{xs: 1, sm: 0}} marginLeft={{xs: 0, sm: '24px'}}
                                      sx={{"&:hover": {textDecoration: 'underline', textDecorationColor: '#000'}}}>
                                    <Box display={'flex'} alignItems={'center'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14"
                                             fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M6.66667 2.33392C6.66667 1.96592 6.368 1.66792 6.00067 1.66792H5.66667C5.66665 2.0098 5.4093 2.29156 5.07775 2.33007L5 2.33455H3C2.63182 2.33455 2.33335 2.03609 2.33333 1.66792H1.99867C1.63133 1.66792 1.33333 1.96592 1.33333 2.33392V11.6686C1.33333 12.0366 1.63133 12.3346 1.99867 12.3346H6.00067C6.368 12.3346 6.66667 12.0366 6.66667 11.6686V2.33392ZM1.334 0.333252H6.66533C7.402 0.333252 8 0.930585 8 1.66725V12.3353C8 13.0719 7.402 13.6693 6.66533 13.6693H1.334C0.597333 13.6693 0 13.0719 0 12.3353V1.66725C0 0.930585 0.597333 0.333252 1.334 0.333252Z"
                                                  fill="#323232"/>
                                        </svg>
                                        <Typography sx={{color: "#323232"}} ml={1} component={'span'} fontWeight={700}>Text
                                            Me</Typography>
                                    </Box>
                                </Link>}
                                { showPhones && <Link href={this.getWhatsAppUrl(ambassador)} onClick={this.clickWhatsApp}
                                      underline={'none'} marginTop={{xs: 1, sm: 0}}
                                      marginLeft={{xs: '24px', sm: '24px'}}
                                      sx={{"&:hover": {textDecoration: 'underline', textDecorationColor: '#000'}}}>
                                    <Box display={'flex'} alignItems={'center'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                             viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M14.6666 7.83031C14.6666 11.4182 11.7333 14.3273 8.12113 14.3273C6.97568 14.3273 5.89689 14.0364 4.95749 13.5212L1.33325 14.6727L2.51507 11.1879C1.92113 10.2061 1.57568 9.06062 1.57568 7.83637C1.57568 4.24243 4.50901 1.33334 8.12113 1.33334C11.7333 1.33334 14.6666 4.24243 14.6666 7.83031ZM8.12113 2.36971C5.08477 2.36971 2.6181 4.81819 2.6181 7.83031C2.6181 9.02425 3.00598 10.1333 3.66659 11.0303L2.98174 13.0606L5.09689 12.3879C5.96356 12.9576 7.00598 13.2909 8.12719 13.2909C11.1636 13.2909 13.6302 10.8424 13.6302 7.83031C13.6302 4.81819 11.1575 2.36971 8.12113 2.36971ZM11.4242 9.32728C11.3817 9.26062 11.2787 9.21819 11.1151 9.1394C10.9575 9.06062 10.1636 8.67274 10.0181 8.62425C9.87265 8.56971 9.76356 8.54546 9.65446 8.70304C9.54537 8.86062 9.24234 9.21819 9.14537 9.32728C9.05446 9.43637 8.95749 9.44849 8.79992 9.36971C8.63628 9.29092 8.12113 9.12122 7.50901 8.58183C7.03022 8.15759 6.70901 7.63637 6.6181 7.4788C6.52719 7.32122 6.60598 7.23637 6.69083 7.15153C6.76356 7.0788 6.85446 6.96365 6.93325 6.87274C7.01204 6.78183 7.04234 6.71516 7.09083 6.60607C7.14537 6.49698 7.11507 6.40607 7.07871 6.32728C7.03628 6.24849 6.71507 5.46668 6.58174 5.14546C6.4484 4.83031 6.31507 4.83637 6.2181 4.83637C6.12113 4.83637 5.95143 4.86668 5.95143 4.86668C5.95143 4.86668 5.63022 4.9091 5.48477 5.06668C5.33931 5.22425 4.92113 5.61213 4.92113 6.39395C4.92113 7.17577 5.49689 7.93334 5.57568 8.04243C5.65446 8.15153 6.68477 9.80607 8.31507 10.4485C9.94537 11.0849 9.94537 10.8727 10.2423 10.8485C10.5333 10.8243 11.1939 10.4667 11.3272 10.0909C11.4605 9.72122 11.4605 9.40001 11.4242 9.33334V9.32728Z"
                                                  fill="#323232"/>
                                        </svg>
                                        <Typography sx={{color: "#323232"}} ml={1} component={'span'}
                                                    fontWeight={700}>WhatsApp</Typography>
                                    </Box>
                                </Link>}
                            </Box>
                        </Grid>
                    </Grid>
                </Container>

                <Dialog open={this.state.openText} maxWidth={'sm'} fullWidth>
                    <IconButton onClick={this.closeModal} sx={{position: 'absolute', right: 0, top: 0}}>
                        <CloseOutlinedIcon sx={{width: 24, height: 24, fill: '#323232'}}/>
                    </IconButton>
                    <Box px={'32px'} pt={'32px'}>
                        <Typography fontSize={'26px'} lineHeight={'32px'} mb={1} fontWeight={700}>Text Me</Typography>
                        <Typography variant={'body1'}>Scan the code to text me from your mobile device.</Typography>
                    </Box>
                    <DialogContent sx={{justifyContent: 'center', display: 'flex', padding: '32px'}}>
                        <QRCode
                            size={160}
                            width={160}
                            height={160}
                            value={this.getSMS(true)}
                        />
                    </DialogContent>
                </Dialog>

                <Dialog open={this.state.openWhatsApp} maxWidth={'sm'} fullWidth>
                    <IconButton onClick={this.closeModal} sx={{position: 'absolute', right: 0, top: 0}}>
                        <CloseOutlinedIcon sx={{width: 24, height: 24, fill: '#323232'}}/>
                    </IconButton>
                    <Box px={'32px'} pt={'32px'}>
                        <Typography fontSize={'26px'} lineHeight={'32px'} mb={1} fontWeight={700}>WhatsApp</Typography>
                        <Typography variant={'body1'}>Scan the code to message me from your mobile device or <Link
                            href={this.getWhatsAppUrl(ambassador)} target={'_blank'}
                            sx={{color: '#000', textDecorationColor: '#000'}}><Typography fontWeight={700}>use WhatsApp
                            on your computer.</Typography></Link></Typography>

                    </Box>
                    <DialogContent sx={{justifyContent: 'center', display: 'flex', padding: '32px'}}>
                        <QRCode
                            size={160}
                            width={160}
                            height={160}
                            value={this.getWhatsAppUrl(ambassador)}
                        />
                    </DialogContent>
                </Dialog>
            </Box>
            <Container>
                <Box display={'flex'} width={'100%'} pt={{xs: 3, sm: 5}} pb={{xs: 3, sm: 4}}
                     flexDirection={{xs: 'column-reverse', sm: 'unset'}} alignItems={'center'}>
                    <Box display={'flex'} flexGrow={1} pt={{xs: 3, sm: 0}}>
                        <Typography fontSize={{xs: '20px', sm: '28px'}} lineHeight={{xs: '24px', sm: '32px'}}
                                    component={'span'}>Latest Posts</Typography>
                    </Box>
                    <Box display={'flex'} flexWrap={'wrap'} className={'storefront-socials'}>
                        {
                            socials.map(this.renderSocials)
                        }
                    </Box>
                </Box>
            </Container>
        </div>

    }
}

export default AmbassadorHeader;